<template>
    <section class="limiter-content pa-3 pa-lg-0">
        <div class="padding-block"></div>

        <!-- Cabecalho no padrao das telas da area do credor/procurador -->
        <header class="dm-header">
            <span class="dm-eyebrow">
                <v-icon small color="primary">{{ isProcurator ? "mdi-briefcase-account-outline" : "mdi-account-circle-outline" }}</v-icon>
                {{ isProcurator ? "ÁREA DO PROCURADOR" : "ÁREA DO CREDOR" }}
            </span>
            <h1 class="dm-title">Modelos <span>de documentos</span></h1>
            <p class="dm-subtitle">Modelos para baixar, preencher e enviar nos seus pedidos à Administração Judicial.</p>
        </header>

        <!-- Texto configurado pelo AJ -->
        <div v-if="dataset.description" class="dm-intro" v-html="dataset.description"></div>

        <div class="dm-toolbar">
            <v-text-field v-model="search" prepend-inner-icon="mdi-magnify" outlined dense hide-details clearable
                placeholder="Pesquisar modelo" class="dm-search"></v-text-field>
            <span class="dm-count">{{ filteredDocuments.length }} {{ filteredDocuments.length === 1 ? "modelo" : "modelos" }}</span>
        </div>

        <v-progress-linear v-if="loading" indeterminate color="darkSecondary" class="mb-3"></v-progress-linear>

        <div v-else-if="!filteredDocuments.length" class="dm-empty">
            <div class="dm-empty__icon"><v-icon size="34" color="darkSecondary">mdi-file-search-outline</v-icon></div>
            <div class="dm-empty__title">{{ search ? "Nenhum modelo encontrado" : "Nenhum modelo disponível" }}</div>
            <div class="dm-empty__text">{{ search ? "Tente pesquisar por outro nome." : "Os modelos publicados pela Administração Judicial aparecem aqui." }}</div>
        </div>

        <div class="dm-grid">
            <a v-for="(item, index) in filteredDocuments" :key="index" :href="item.file_url" target="_blank" rel="noopener" class="dm-card">
                <span class="dm-card__icon"><v-icon color="darkSecondary">mdi-file-document-outline</v-icon></span>
                <span class="dm-card__name">{{ item.name }}</span>
                <span class="dm-card__download"><v-icon small>mdi-download</v-icon> Baixar</span>
            </a>
        </div>

        <v-row>
            <whatsButton />
        </v-row>

        <v-row>
            <topButton />
        </v-row>
    </section>
</template>

<script>
import 'moment/locale/pt-br';
import axios from 'axios';

import { eventHub } from "@/main";
import topButton from '@/components/layout/GoToTopButton.vue';
import whatsButton from '@/components/layout/WhatsAppButton.vue';

export default {
    components: {
        topButton,
        whatsButton,
    },

    data: () => ({
        user: null,
        dialogPopup: false,
        loading: false,
        search: "",
        dataset: {
            documents: [],
            description: '',
        }
    }),

    mounted: function () {
    },

    computed: {
        isProcurator() {
            return !!this.$root.user && Number(this.$root.user.type) === 2;
        },
        filteredDocuments() {
            const term = String(this.search || "").trim().toLowerCase();
            if (!term) return this.dataset.documents;
            return this.dataset.documents.filter((item) => String(item.name || "").toLowerCase().includes(term));
        },
    },

    created() {
        this.$ga.event({
            eventCategory: 'page',
            eventAction: 'action',
            eventLabel: 'click',
            eventValue: 'home'
        })

        this.loadText();
        this.loadDocuments();
    },

    methods: {
        openRegister() {
            eventHub.$emit("DIALOG-REGISTER", true)
        },

        async loadText() {
            try {
                const result = await axios.get(`/api/dynamic-infos/keys`, {
                    params: { keys: 'documents-template-description' }
                });

                if (result.data.content && result.data.content.length > 0) {
                    this.dataset.description = result.data.content[0].value;
                } else {
                    this.dataset.description = '';
                }

            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            }
        },

        async loadDocuments() {
            this.loading = true;
            try {
                const result = await axios.get('/api/document-models')

                this.dataset.documents = result.data.content.data

            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 5000
                })
            } finally {
                this.loading = false;
            }
        }

    }
};
</script>

<style lang="scss">
.title-page {
    color: var(--v-primary-base);
    font-family: "Raleway";
    font-size: 40px;
    font-style: normal;
    font-weight: 700;
    line-height: 38px;
}
</style>

<style scoped>
/* Mesmo padrao visual das telas da area do credor/procurador. */
.dm-header { padding: 32px 0 24px; }
.dm-eyebrow { display: flex; gap: 8px; align-items: center; font-size: 11px; font-weight: 700; letter-spacing: .12em; color: #766386; }
.dm-title { margin: 14px 0 10px; font-size: clamp(28px, 3.4vw, 40px); font-weight: 700; color: #25113c; letter-spacing: -.035em; line-height: 1.2; }
.dm-title span { color: #806697; }
.dm-subtitle { margin: 0; color: #73677c; font-size: 14px; }

.dm-intro { padding: 16px 20px; border-radius: 14px; background: rgba(120, 119, 229, .09); color: #2a1a40; font-size: 14px; line-height: 1.6; margin-bottom: 24px; }
.dm-intro ::v-deep p:last-child { margin-bottom: 0; }

.dm-toolbar { display: flex; align-items: center; justify-content: space-between; gap: 12px 16px; flex-wrap: wrap; margin-bottom: 14px; }
.dm-search { max-width: 420px; width: 100%; }
.dm-search ::v-deep fieldset { border-color: rgba(126, 85, 171, .45); border-radius: 10px; }
.dm-search:hover ::v-deep fieldset { border-color: #7e55ab; }
.dm-search ::v-deep .v-input__slot { border-radius: 10px !important; }
.dm-count { font-size: 12px; color: rgba(24, 0, 50, .5); }

.dm-grid { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 10px; margin-bottom: 40px; }
.dm-card { display: grid; grid-template-columns: auto minmax(0, 1fr) auto; align-items: center; gap: 14px; padding: 14px 16px; border-radius: 14px; background: #fff; border: 1px solid rgba(24, 0, 50, .07); text-decoration: none; transition: border-color .15s ease, box-shadow .15s ease; }
.dm-card:hover, .dm-card:focus-visible { border-color: rgba(120, 119, 229, .45); box-shadow: 0 6px 20px rgba(24, 0, 50, .07); outline: none; }
.dm-card__icon { width: 40px; height: 40px; border-radius: 50%; display: flex; align-items: center; justify-content: center; background: rgba(120, 119, 229, .12); }
.dm-card__name { font-size: 14px; font-weight: 600; color: #180032; overflow-wrap: anywhere; }
.dm-card__download { display: inline-flex; align-items: center; gap: 4px; font-size: 13px; font-weight: 600; color: #7e55ab; white-space: nowrap; }
.dm-card__download .v-icon { color: inherit; }

.dm-empty { text-align: center; padding: 40px 16px 56px; }
.dm-empty__icon { width: 72px; height: 72px; border-radius: 50%; margin: 0 auto 16px; display: flex; align-items: center; justify-content: center; background: rgba(120, 119, 229, .12); }
.dm-empty__title { font-size: 17px; font-weight: 600; color: #180032; }
.dm-empty__text { margin-top: 6px; color: rgba(24, 0, 50, .6); font-size: 14px; }

@media (max-width: 760px) {
    .dm-grid { grid-template-columns: 1fr; }
    .dm-search { max-width: none; }
}
</style>
